// src/pages/tenant/TenantEditPage.tsx
// Legacy route kept resolvable for old links/bookmarks. Tenants are edited
// inline on TenantDetailPage now — there is no edit route/mode, per
// docs/ux/14-forms.md. This route just sends people to the detail page.

import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const TenantEditPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  useEffect(() => {
    navigate(id ? `/tenants/${id}` : '/tenants', { replace: true });
  }, [navigate, id]);
  return null;
};

export default TenantEditPage;
